import { createSlice } from "@reduxjs/toolkit";
import {
  getDocuments,
  addDocument,
  updateDocument,
  deleteDocument,
} from "./actions/document";

const initialState = {
  document: null,
  documents: null,
  total: 0,
  loading: false,
  isEditing: false,
};

export const documentSlice = createSlice({
  name: "document",
  initialState,
  reducers: {
    setDocument: (state, action) => {
      const document = state.documents.find(
        (_document) => _document.id === action.payload
      );
      state.document = document;
    },
    setIsEditing: (state, action) => {
      state.isEditing = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDocuments.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDocuments.fulfilled, (state, action) => {
        state.loading = false;
        state.documents = action.payload.data;
        state.total = action.payload.count;
      })
      .addCase(getDocuments.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(addDocument.pending, (state) => {
        state.loading = true;
      })
      .addCase(addDocument.fulfilled, (state, action) => {
        state.loading = false;
        window.location.hash = "#/profile/document";
      })
      .addCase(addDocument.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(updateDocument.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateDocument.fulfilled, (state, action) => {
        state.loading = false;
        state.isEditing = false;
        state.document = action.payload;
      })
      .addCase(updateDocument.rejected, (state) => {
        state.loading = false;
      });
    builder
      .addCase(deleteDocument.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteDocument.fulfilled, (state) => {
        state.loading = false;
        window.location.hash = "#/profile/document";
      })
      .addCase(deleteDocument.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setDocument, setIsEditing } = documentSlice.actions;

export default documentSlice.reducer;
